import { useCallback, useEffect, useState } from 'react';
import { getStep } from 'api/ppaOnboarding';
import { IPPAOnboardingStepResponse } from 'types/ppaOnboarding';
import { message } from 'antd';

const useGetPPAOnboardingStep = (): [IPPAOnboardingStepResponse | undefined, boolean, () => Promise<void>] => {
    const [data, setData] = useState<IPPAOnboardingStepResponse>();
    const [loading, setLoading] = useState(false);

    const fetch = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getStep();
            if (res && !res.error) {
                setData(res.data?.data);
            } else {
                message.error(res?.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return [data, loading, fetch];
};

export default useGetPPAOnboardingStep;
